import { DialogTitle, DialogWindow } from '../components/widgets/dialog';
import { PrimaryButton } from '../components/widgets/buttons';
import styled from 'styled-components';
import { Hr } from '../components/pages/platformSelection/platformConnection';

export const IFrameContainer = styled.div`
    justify-self: center;
    margin: 0 0 20px 0;
`;

export const IFrame = styled.iframe`
    border: none;
    width: 554px;
    height: 312px;
    justify-content: center;
    margin: 0;
    padding: 5px 10px 5px 5px;
    inset: 5px 5px 5px 5px;
`;

export const InstructionLabel = styled.p`
    margin: 0;

    * {
        margin: 0;
    }
`;

export const ApiLabel = styled.p`
    margin: 0 0 20px 0;

    * {
        margin: 0;
    }
`;

export const Note = styled.p`
    margin: 16px 0 0 0;
`;

export const InstructionsList = styled.ol`
    margin: 16px 0;
    padding-inline-start: 26px;
`;

export const PointedInstructionsList = styled.ul`
    margin: 16px 0;
    padding-inline-start: 26px;
`;

export const InstructionItem = styled.li`
    &:nth-child(n + 2) {
        padding-top: 8px;
    }

    > p {
        margin: 0 !important;
    }

    > pre {
        background: #dbe2e6;
        display: flex;
        width: 492px;
        height: 66px;
        padding: 16px 10px;
        align-items: center;
        gap: 10px;
    }

    * img {
        width: 100%;
    }
`;

export const ActionContainer = styled.div`
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    padding-top: 8px;
    align-items: flex-start;
    gap: 40px;
    align-self: stretch;
`;

export const AddSalesChannelsDialogWindow = styled(DialogWindow)`
    padding: 20px 40px;
    max-height: 99vh;

    ${DialogTitle} {
        margin: 0 0 20px 0;
        font-size: 20px;
    }
`;

export const ConnectShopDialogWindow = styled(DialogWindow)`
    width: 566px;
    padding: 20px 40px;
    max-height: 760px;
    flex-basis: unset;

    ${DialogTitle} {
        margin: 0 0 20px 0;
        font-size: 20px;
    }
`;

export const DescriptionContent = styled.p`
    margin: 20px 0;
    align-self: stretch;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

export const CenteredButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    flex: 2;
    align-items: center;

    ${PrimaryButton} {
        min-width: 150px;
    }
`;

export const DoubleHr = styled(Hr)`
    margin: 40px 0;
`;
